var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive bg-white radius"},[_c('ArchivedTasks',{staticClass:"m-4",attrs:{"scope":"ACCOUNT"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }